var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balance-changes-container"},[_c('balance-changes-block',{staticClass:"balance-changes"},[_c('balance-changes-table')],1),_c('deposit-block',{staticClass:"deposit"}),_c('month-spending-block',{staticClass:"month-spending"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }